import React from "react";
import { connect } from "react-redux";

class ToastMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { messages: {} };
  }

  hideMessage = (itemKey) => {
    const { messages } = this.state;
    messages[itemKey].show = false;
    this.setState({ messages });
  };

  addMessage(message) {
    const { messages } = this.state;
    for (let i in messages) {
      if (message.message_id != i && messages[i].show === false) {
        delete messages[i];
      }
    }
    if (typeof message == "object" && !messages[message.message_id]) {
      messages[message.message_id] = message;
    }
  }

  getIconForType(type) {
    const lowerType = type.toLowerCase();

    if (lowerType === "success") {
      return (
        <svg
          className="text-green-400 size-6"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          ></path>
        </svg>
      );
    } else if (lowerType === "danger") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="text-red-400 size-6"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 9.75V13.75M12 16.24V16.25M12 3.25L2.5 19.25H21.5L12 3.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </svg>
      );
    } else if (lowerType === "warning") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="text-yellow-400 size-6"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 9.75V13.75M12 16.24V16.25M12 3.25L2.5 19.25H21.5L12 3.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </svg>
      );
    } else if (lowerType === "info") {
      return (
        <svg
          className="text-blue-400 size-6"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
          ></path>
        </svg>
      );
    } else {
      return (
        <svg
          className="text-gray-400 size-6"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
          ></path>
        </svg>
      );
    }
  }

  getBackgroundColor(type) {
    const lowerType = type.toLowerCase();

    switch (lowerType) {
      case "success":
        return "bg-green-50";
      case "danger":
        return "bg-red-50";
      case "warning":
        return "bg-yellow-50";
      case "info":
        return "bg-blue-50";
      default:
        return "bg-gray-50";
    }
  }

  buildToasts() {
    const { messages } = this.state;
    const hideMessage = this.hideMessage;
    const messageKeys = Object.keys(messages);

    if (messageKeys && messageKeys.length > 0) {
      return messageKeys.map((itemKey) => {
        const message = messages[itemKey];
        if (!message.show) return null;

        return (
          <div
            key={itemKey}
            className={`p-4 mb-2 shadow-md ${this.getBackgroundColor(
              message.type
            )}`}
          >
            <div className="flex items-start">
              <div className="shrink-0">
                {this.getIconForType(message.type)}
              </div>
              <div className="flex-1 pt-0.5 ml-3 w-0">
                <p className="text-sm font-medium text-gray-900">
                  {message.header}
                </p>
                <p className="mt-1 text-sm text-gray-500">{message.message}</p>
              </div>
              <div className="flex ml-4 shrink-0">
                <button
                  type="button"
                  onClick={() => hideMessage(itemKey)}
                  className="inline-flex text-gray-400 rounded-md hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
                >
                  <span className="sr-only">Close</span>
                  <svg
                    className="size-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        );
      });
    }
    return null;
  }

  render() {
    const { message } = this.props;
    const { messages } = this.state;

    if (typeof message === "object") {
      this.addMessage(message);
    }

    const messageKeys = Object.keys(messages);
    if (messageKeys && messageKeys.length > 0) {
      return (
        <div className="fixed right-0 bottom-0 z-50 p-4 space-y-2 min-w-[310px] sm:min-w-[400px]">
          {this.buildToasts()}
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps(state) {
  const { message } = state;
  return {
    message,
  };
}

export default connect(mapStateToProps)(ToastMessage);
